import type { IPermissionPort } from "@src/domain/ports";

export class PermissionCheckService implements IPermissionPort {
    hasAnyPermission(requiredPermissions: string[], permissionsSet: string[]): boolean {
      return requiredPermissions.some(permission => permissionsSet.includes(permission));
    }
  
    hasAllPermissions(requiredPermissions: string[], permissionsSet: string[]): boolean {
      return requiredPermissions.every(permission => permissionsSet.includes(permission));
    }
  }
  